export enum PayoutRuleType {
    vendor = "vendor",
    commission = "commission",
    referral = "referral"
}
